jQuery( $ => {
	/**
	 * Whenever an ajax is complete.
	 * TODO: this should probably be more specific.
	 */
	$( document ).ajaxComplete( function() {
		toggleMaxQuantity();
	} );

	/**
	 * Toggles whether the plus button should be disabled due to the maximum value reached.
	 */
	function toggleMaxQuantity() {
		$( '.qty input[type=number]' ).each( function() {
			const quantityValue = $( this );
			const plusButton = quantityValue.closest( '.quantity-wrapper' ).find( '.plus' );
			if ( quantityValue.attr( 'max' ) ) {
				if ( parseInt( quantityValue.val() ) >= parseInt( quantityValue.attr( 'max' ) ) ) {
					plusButton.attr( 'disabled', true );
				}
			}
		} );
	}

	/**
	 * Increment/decrement product quantity when clicking the buttons on a single product.
	 */
	$( 'body' ).on( 'click', '.quantity-modifier', function() {
		const triggerEl = $( this );
		const quantityInput = triggerEl.closest( '.quantity-wrapper' ).find( '.qty' );
		changeProductQuantity( quantityInput, triggerEl.data( 'operand' ), 1 );
	} );

	/**
	 * Modify a products quantity input.
	 *
	 * @param {Object} quantityInput the quantity input element.
	 * @param {string} operand       the operand which is used to change the quantity
	 * @param {number} modification  the modifying value.
	 */
	function changeProductQuantity( quantityInput, operand, modification = 1 ) {
		let quantity = quantityInput.val();

		// If quantity is already 1 and they click to subtract we just return without doing anything.
		if ( '-' === operand && 1 >= parseInt( quantity ) ) {
			return;
		}

		const max = quantityInput.attr( 'max' );

		// Or if they've already reached the maximum allowed quantity.
		// We set the quantity the the max value just as a safety precaution and then bail.
		if ( '' !== max && 0 < parseInt( max ) && quantity >= parseInt( max ) && '+' === operand ) {
			quantityInput.val( parseInt( max ) );
			// if we return here, it is not obvious that user has reached max qty. without return, browser tooltip about max quantity is displayed after lose focus or a couple of seconds
		}

		// Add focus to the input.
		quantityInput.focus();

		// Recalculate quantity and change the input value.
		quantity = eval( quantity + operand + modification ); // eslint-disable-line no-eval
		quantityInput.val( quantity ).trigger( 'change' );

		// Make update cart button enabled if on checkout
		$( 'button[name="update_cart"]' ).prop( 'disabled', false );
	}

	/**
	 * Maybe trigger a cart update when leaving a quantity input.
	 */
	$( 'body' ).on( 'blur', '.qty', () => {
		triggerCartUpdate();
	} );

	/**
	 * Maybe trigger a cart update after an interval of time
	 * We do not do this instantly because we want to allow the user the time to change the quantity as much as they like before triggering an update.
	 */
	function triggerCartUpdate() {
		const updateEl = $( 'button[name="update_cart"]' );
		if ( 0 < updateEl.length ) {
			setTimeout( () => {
				// Bail if currently focused element is a quantity box.
				if ( $( '.qty' ).is( ':focus' ) ) {
					return;
				}
				// Otherwise we should trigger an update!
				updateEl.trigger( 'click' );
			}, 1000 );
		}
	}
} );
